
import { computed, defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default defineComponent({
  props: {
    linkUrl: {
      type: String,
      required: true,
    },
    linkTarget: {
      type: String,
      required: false,
    },
    linkTitle: {
      type: String,
      required: false,
    },
    active: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    customHandler: {
      type: Function,
      required: false,
    },
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();

    const currentPage = computed(() => store.getters['page/page']);
    const isActive = computed(() => props.active || (
      currentPage.value && currentPage.value.url === props.linkUrl
    ));

    const routeParts = props.linkUrl.split(window.location.host);
    const routePath = routeParts[routeParts.length - 1];

    const navigate = (e: Event) => {
      if ([undefined, null, '_self'].indexOf(props.linkTarget) >= 0) {
        e.preventDefault();

        if (typeof props.customHandler === 'function') {
          props.customHandler(() => {
            router.push(routePath);
          });
        } else {
          router.push(routePath);
        }
      }
    };

    return {
      currentPage,
      isActive,
      router,
      routePath,
      navigate,
    };
  },
});
